<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="checklist_template"
    :parentId="$route.params.id"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/checklist_conclusion_daily_template";
export default {
  data: () => ({
    modelName: "checklist_conclusion_daily_template_version",
    label: "每日點檢表公版版本",
    fields: model.fields.last_version.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "版本內容",
              fields: ["locales"],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>